// @flow
import { createReducer } from 'redux-act';

import type { Pagination as State } from '../../types';
import { set, reset } from '../actions/pagination';

type PaginationEventData = {
  per_page: number,
  page: number,
  'X-Total-Count': number,
};

const initialState: State = {
  page: 1,
  perPage: 30,
};

function setHandler(state: State, pagination: PaginationEventData): State {
  const newState = {
    ...state,
    page: pagination.page,
  };

  if (pagination.per_page) newState.perPage = pagination.per_page;
  if (pagination['X-Total-Count']) newState.total = pagination['X-Total-Count'];
  return newState;
}

function resetHandler(): State {
  return initialState;
}

export default (createReducer(
  {
    [set.toString()]: setHandler,
    [reset.toString()]: resetHandler,
  },
  initialState,
): {
  (): (
    state: null | { page: number, perPage: number, total: number },
    payload?: mixed,
    meta?: mixed,
  ) => null | { page: number, perPage: number, total: number },
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<null | { page: number, perPage: number, total: number }>,
  options: () => mixed,
  ...
});
